import { CloseOutlined } from '@ant-design/icons';
import { Button, Checkbox, Radio, Space, Spin, Table, Tooltip, Typography } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { QuestionCircleTwoTone } from '@ant-design/icons';
import { apiCall } from "../utils/Api";
import Overlay from './Overlay';
import PeerDataMarketSelector from './title/PeerDataMarketSelector';
import Html from '../utils/Html';
import { useSession } from '../utils/Session';

export default function PeerSales(props) {

    const {
        setShowActivity = () => { },
        isbn = "" } = props;
    const [results, setResults] = useState({ rows: [] })
    const [summary, setSummary] = useState({});
    const [loading, setLoading] = useState(true);
    const [group, setGroup] = useState([]);

    const [session, setSession] = useSession();


    const [filters, setFilters] = useState({
        period: "month",
        summarize_province: false,
        location_group: "",
        isbn: isbn,
        just_my_accounts: false,
        not_carried: false,
        group_list_id: ""
    });

    const [locationGroups, setLocationGroups] = useState({});

    const getPeerSales = () => {
        // setLoading(true)
        apiCall("title/getPeerSalesBreakdown", filters, (_status, _result) => {
            if (_status) {
                // first row is summary data.. 
                let _summary = _result.rows.shift();
                setSummary(_summary);
                setResults(_result);
                setLoading(false)
            }
        })
    }

    const getGroupList = () => {
        apiCall("contact_list/getAll", {}, (_status, _result) => {
            if (_status) {
                setGroup(_result.contact_lists);
            }
        })
    }

    /* 
        Below API Call data structure
        {
            "id": "113984",
            "san": "7603800",
            "name": "Talisman Books & Gallery",
            "shared": false
        },
    */
    const getLocations = () => {
        apiCall("title/getLocationPickerData", {}, (_status, _result) => {
            if (_status) {
                setLocationGroups(_result);
                setFilters(f => ({
                    ...f,
                    location_group: _result.default_key
                }));
            }
        })
    }

    const date_tooltip = <>

        Monthly / Weekly Daily sales toggle:<div className="shim" /><div className="shim" />
        Monthly is the default here, and you will see the current month's sales + the previous 12 months<div className="shim" /><div className="shim" />
        Weekly provides sales for the last seven days, including today. (For example, if you are looking at this weekly section on Aug15th, the rightmost column will say A15, and that data is displaying sales from Aug9-15.)<div className="shim" /><div className="shim" />
        Daily is exactly that - daily sales!<div className="shim" /><div className="shim" />
        <em>Note: the sales data here is updated when we receive weekly sales files, or, store backups - which typically only come in once a day, generally overnight. A store can push through a new backup, to have this daily number updated, but this is a manual process!</em>
    </>

    const oo_oh_tooltip = <>

        aOH/aOO Information:<div className="shim" /><div className="shim" />
        Current available on hand and on order data is collected daily from indie bookstores across the country...<div className="shim" /><div className="shim" />
        aOH column: provides the current number of copies available on store shelves. (These numbers are updated nightly.)<div className="shim" /><div className="shim" />
        aOO column: provides the current number of copies available on order. (These numbers are updated nightly.)<div className="shim" /><div className="shim" />
        (Note: the aOO numbers do not include any quantities that may be presently sitting in store 'biz' carts - to view that data you must look at the store data tab.)
    </>

    useEffect(getLocations, []);

    useEffect(() => {
        if (filters.location_group) {
            getPeerSales();
            getGroupList();
        }
    }, [filters]);
    let columns = [];
    columns.push({ title: <small></small>, width: "5px", dataIndex: "blank", key: "blank" });
    if (filters.summarize_province) {
        columns.push({
            title: <small>Flag</small>,
            dataIndex: "flag",
            className: "cellBorder",
            width: "40px",
            key: "flag",
            render: (e, f) => {
                let flag_path = "https://cdn1.bookmanager.com/i/flags/" + f.country + "_" + f.province + ".png";
                flag_path = flag_path.replace(" ", "");
                return (<Tooltip title={<small>{f.name}</small>}><img onLoad={e => e.currentTarget.style.display = "inline"} onError={e => e.target.style.display = 'none'} style={{ "maxWidth": "17px", "cursor": "pointer" }} src={flag_path} /> {f.province}</Tooltip>)
            }
        })
    }


    // Add months procedurally
    let loopNumForWeekFilter = filters.period === "week" ? 11 : 12;
    for (let i = loopNumForWeekFilter; i >= 0; i--) {
        let start = (filters.period === "week") ? moment().startOf("week").add(-1, "day") : moment();
        let month = start.add(-i, filters.period).format((filters.period === "month") ? "MMM" : "MMMD");
        columns.push({ title: <small>{month}</small>, width: "40px", className: (i === 0 && filters.period !== "week") ? "cellBorder" : "", dataIndex: filters.period + i.toString(), key: filters.period + i.toString(), render: (e) => e || "" });
    }
    // Add Week bs
    if (filters.period === "week") {
        columns.push({ title: <small style={{ "color": "#888" }}>{moment().format("MMM D")}</small>, width: "40px", className: "cellBorder", dataIndex: "week", key: "week", render: (e) => { return <span style={{ "color": "#888" }}>{(e) ? e : ""}</span> } })
        columns.push({ title: <small><strong>Total</strong></small>, className: "cellBorder", dataIndex: "total", key: "total", render: (e) => { return <strong>{(e) ? e : ""}</strong> } })
    } else {
        columns.push({ title: <small style={{ "borderLeft": "1px" }}><strong>Total</strong></small>, className: "cellBorder", dataIndex: "total", width: "100px", key: "total", render: (e) => { return <strong>{(e) ? e : ""}</strong> } })
    }
    // Clone columns from summary
    let summary_columns = [...columns];
    // drop the first three columns()
    summary_columns.shift();
    summary_columns.shift();
    summary_columns.shift();
    if (filters.summarize_province) {
        summary_columns.shift();
    }
    if (!filters.summarize_province) {
        columns.push({
            title: <small>Price</small>, width: "50px", className: "cellBorder", dataIndex: "price", key: "price", render: (e) => {
                return (e) ? <nobr>{e.toString()}</nobr> : "";
            }
        })
    }
    columns.push({
        title: (
            <Tooltip overlayStyle={{ maxWidth: '500px' }} title={<div><small>{oo_oh_tooltip}</small></div>}>
                <small>
                    <nobr>aOH</nobr>
                </small>
            </Tooltip>
        ),
        width: "50px",
        className: "cellBorder",
        dataIndex: "onhand",
        key: "onhand",
        render: (e) => {
            return <div style={{ color: "#008000", textAlign: "center" }}>{e ? e : ""}</div>;
        }
    });
    columns.push({
        title: (
            <Tooltip overlayStyle={{ maxWidth: '500px' }} title={<div><small>{oo_oh_tooltip}</small></div>}>
                <small>
                    <nobr>aOO</nobr>
                </small>
            </Tooltip>
        ), width: "50px", className: "cellBorder", dataIndex: "onorder", key: "onorder", render: (e) => {
            return <div style={{ "color": "#FFA500", "textAlign": "center" }}>{(e) ? e : ""}</div>
        }
    })
    if (!filters.summarize_province) {
        columns.push({
            title: <small>Name</small>, className: "cellBorder", dataIndex: "name", key: "name", render: (e, f, i) => {
                const match = e.match(/\((\d+)/); // get the first number after the bracket
                if (i === 0 && match) {
                    return (<Tooltip title={<small>{match[1]} active stores have sold this ISBN in the last 13 months, or currently have it O/H or O/O, in real time</small>}><Html className="" html={e} /></Tooltip>)
                }
                return <div><Html className="" html={e} /></div>;
            }
        })
    }

    const parseData = () => {
        if (loading) {
            return ([]);
        }
        return results.rows.map((item, index) => {
            let m = { ...item };
            for (let i = 12; i >= 0; i--) {

                m[filters.period + i.toString()] = m.values[i];
            }
            return m;
        })
    }

    const filterNotCarried = (_arr = []) => {

        if (filters?.not_carried) {
            return _arr.filter(item => !item?.onhand && !item?.onorder);
        } else {
            return _arr;
        }
    }

    const parseSummary = () => {
        if (loading) {
            return ([]);
        }
        let _summary = [{ ...summary }];
        return _summary.map((item, index) => {
            let m = { ...item };
            for (let i = 12; i >= 0; i--) {
                m[filters.period + i.toString()] = m.values[i];
            }
            return m;
        })
    }

    const drawHeader = () => {
        return (
            <>
                <div>
                    <div className="bc" style={{ "borderBottom": "1px solid", "height": "29px" }}>
                        <div style={{ "padding": "2px 5px", "marginTop": "0px" }} >
                            <span style={{ "fontSize": "13px" }}>
                                <Space>
                                    <Tooltip title="Summarize grid data by province or state">
                                        <Checkbox
                                            className="mini-checkbox"
                                            value={filters.summarize_province}
                                            onChange={(e) => setFilters({ ...filters, "summarize_province": e.target.checked })}>
                                            <small>Province/State</small>
                                        </Checkbox>
                                    </Tooltip>

                                    {(((!session?.is_pub_no_sm)) &&
                                        <Tooltip title="Only show accounts sharing with me.">
                                            <Checkbox
                                                className="mini-checkbox"
                                                value={filters.just_my_accounts}
                                                onChange={(e) => setFilters({ ...filters, "just_my_accounts": e.target.checked })}>
                                                <small>Just My Accounts</small>
                                            </Checkbox>
                                        </Tooltip>
                                    )}

                                    {(((!session?.is_pub_no_sm)) &&
                                        <Tooltip title="Only show accounts sharing with me.">
                                            <Checkbox
                                                className="mini-checkbox"
                                                value={filters.not_carried}
                                                onChange={(e) => setFilters({ ...filters, "not_carried": e.target.checked })}>
                                                <small>Not Carried</small>
                                            </Checkbox>
                                        </Tooltip>
                                    )}

                                    <div style={{ "float": "right" }}>
                                        {groupPickerMenu()}
                                    </div>

                                    <div style={{ "float": "right" }}>
                                        {locationPickerMenu()}
                                    </div>
                                </Space>
                            </span>
                            <div style={{ "float": "right", "fontSize": "13px" }}>
                                <div style={{ "marginTop": "-10px" }}>
                                    <Radio.Group size="small" style={{ "marginTop": "10px" }} defaultValue={filters.period} onChange={(e) => setFilters({ ...filters, "period": e.target.value })} buttonStyle="solid">
                                        <Radio className="mini-radio" value="month"><span style={{ "fontSize": "13px" }}><small>Monthly</small></span></Radio>
                                        <Radio className="mini-radio" value="week"><span style={{ "fontSize": "13px" }}><small>Weekly</small></span></Radio>
                                        <Radio className="mini-radio" value="day"><span style={{ "fontSize": "13px" }}><small>Daily</small></span></Radio>
                                    </Radio.Group>
                                    <Tooltip overlayStyle={{ maxWidth: '500px' }} title={<div><small>{date_tooltip}</small></div>}>&nbsp;<QuestionCircleTwoTone style={{ "marginRight": "0px", "opacity": "1", "fontSize": "11px", "padding": "0px" }} /></Tooltip>
                                    <Button onClick={() => setShowActivity(false)} className="tiny-btn" size="small" type="text"><small style={{ "fontSize": "10px" }}><CloseOutlined /></small></Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const groupPicker = () => {
        return (
            <div style={{ padding: "20px" }}>
                <Typography.Title level={5}>Select Group List</Typography.Title>
                <div style={{ "paddingBottom": "20px" }}>
                    <Radio.Group onChange={(e) => { setFilters({ ...filters, group_list_id: e.target.value }) }} value={filters.group_list_id}>
                        <Space direction="vertical">
                            <Radio value={""}>{"All Groups (" + group.length + " total)"}</Radio>
                            {group.map((item, _ind) => {
                                return (<Radio key={_ind} value={item.id}>{item.name}</Radio>)
                            })}
                        </Space>
                    </Radio.Group>
                </div>
            </div>
        )
    }

    const groupPickerMenu = () => {
        return (
            <Button
                style={{ "marginRight": "5px" }}
                type="primary"
                size="small"><small>
                    <Overlay
                        width={450}
                        component={groupPicker()}>
                        Group List: ({group.length})
                    </Overlay>
                </small>
            </Button>
        )
    }

    const locationPickerMenu = () => {
        return (
            <Button
                style={{ "marginRight": "5px" }}
                type="primary"
                size="small"><small>
                    <Overlay
                        width={450}
                        component={
                            <PeerDataMarketSelector
                                locationGroups={locationGroups}
                                setFilters={setFilters}
                                filters={filters} />
                        }>
                        Market: {filters.location_group + " (" + locationGroups.locations[filters.location_group].length + ")"}
                    </Overlay>
                </small>
            </Button>
        )
    }


    return (
        <Spin spinning={loading}>
            <div style={{ "minHeight": "100px" }}>
                {!loading &&
                    <div>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <Typography.Title
                            className="bcg4"
                            style={{
                                "fontWeight": "normal",
                                "fontSize": "11px",
                                "display": "inline",
                                "padding": "5px 8px",
                                "borderRadius": "2px 2px 0 0",
                            }}>
                            Raw Peer Data
                        </Typography.Title >
                        <Table
                            columns={columns}
                            title={() => drawHeader()}
                            loading={loading}
                            className={"peerTable bc"}
                            style={{ "border": "1px solid", "borderLeft": "6px solid" }}
                            dataSource={filterNotCarried(parseSummary().concat(parseData()))}
                            scroll={{ y: 240 }}
                            pagination={false}
                            onExpand={(e) => { return false; }}
                        />
                        <div className='shim' />

                    </div>
                }
            </div>
        </Spin>
    )
}
